import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App";
import "./styles.css";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) Sentry.init({ dsn, environment: import.meta.env.MODE, sendDefaultPii: false, tracesSampleRate: 0.1 });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="fatal">InfraTeams konnte nicht geladen werden.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
